module.exports = __webpack_public_path__ + "img/1.8cd61833.png";